import {
  type PermitTypeUnit,
  permitTypeUnit,
} from '@contracts/permitType/PermitType';
import { Brand } from '@src/Branding';
import config from '@src/config/Config';

export const getBrandDefaultPermitTypeUnit = (): PermitTypeUnit => {
  if (config.VITE_BRAND === Brand.Axys) {
    return permitTypeUnit.IMPERIAL;
  }
  return permitTypeUnit.METRIC;
};
